import { NUMBER } from "../../../constants/app-constants";
import { createReducer } from "../../../utils/redux/create-reducer";
import { SCREEN_NAMES } from "./constant";
import Types from "./types";

export const INITIAL_STATE = {
    brand: {},
    model: {},
    registrationNumber: null,
    whatsappConsent: null,
    token: null,
    activeAccordionStepIndex: NUMBER.ZERO,
    activeFormScreen: SCREEN_NAMES.intentScreen,
    newCarPdiLead: null,
    isPdiLeadSelected: false,
    ownerName: "",
    intent: {id: "", text: ""}
};

export const setDetails = (state = INITIAL_STATE, { data }) => {
    return { ...state, ...data };
};

export const setStepDetails = (state = INITIAL_STATE, { data, stepName }) => {
    return { ...state, [stepName]: data };
};

export const setIsTruecaller = (state = INITIAL_STATE, { isTruecaller }) => {
    return { ...state, isTruecaller };
};

export const setActiveAccordionStepIndex = (state = INITIAL_STATE, action) => ({
    ...state, activeAccordionStepIndex: action.payload
});

export const setFormActiveScreen = (state = INITIAL_STATE, action) => ({ ...state, activeFormScreen: action.payload });

export const resetPdiLeadData = () => {
    return INITIAL_STATE;
};

export const setCarTypePdiLead = (state = INITIAL_STATE, {newCarPdiLead}) => ({
    ...state, newCarPdiLead
});

export const HANDLERS = {
    [Types.SET_DETAILS]: setDetails,
    [Types.SET_STEP_DETAILS]: setStepDetails,
    [Types.SET_IS_TRUECALLER]: setIsTruecaller,
    [Types.SET_FORM_ACTIVE_SCREEN]: setFormActiveScreen,
    [Types.SET_ACCORDION_ACTIVE_STEP_INDEX]: setActiveAccordionStepIndex,
    [Types.RESET_PDI_LEAD_DATA]: resetPdiLeadData,
    [Types.SET_CAR_TYPE_PDI_LEAD]: setCarTypePdiLead
};

export default createReducer(INITIAL_STATE, HANDLERS);
